import { RouteObject } from 'react-router-dom';
import { Authorize } from '@/components';
import { BUSINESS_ROLE_GROUPS } from '@/components/security/AppRoles';
import { ErrorPage } from '@/pages/Layout/pages';
import { ApplyAmendment, AmendmentHistory } from '../pages';

const AmendmentsRoutes: RouteObject[] = [
  {
    path: 'amendments',
    children: [
      {
        path: '',
        element: <ApplyAmendment />,
      },
      {
        path: 'history',
        element: (
          <Authorize
            permission={BUSINESS_ROLE_GROUPS.adminOrSupervisor}
            fallback={<ErrorPage code={403} />}
          >
            <AmendmentHistory />
          </Authorize>
        ),
      },
    ],
  },
];

export default AmendmentsRoutes;
